<div class="wrap printMe">
  <div class="header">
    <div class="user_name">
      <fa-icon [icon]="faChevronLeft" [routerLink]="['/users']" routerLinkActive="router-link-active"></fa-icon>
      <ion-avatar>
        <img [src]="imgUserDefault">
      </ion-avatar>
      <h1>{{user?.firstname}} {{user?.lastname}}</h1>
      <div class="start_date_user"> - En poste depuis le : {{user?.startDate | date}}</div>
    </div>
    <div class="header_actions">
      <mat-slide-toggle [color]="color" [checked]="isActive" (change)="isActiveOrNot()">
        {{isActiveValue? "Actif": "Inactif"}}
      </mat-slide-toggle>
      <div class="password_export">
        <fa-icon [icon]="faEdit" (click)="openDialogUpdateUser()"></fa-icon>
        <!-- <fa-icon [icon]="faFileExcel"></fa-icon> -->
      </div>
    </div>
  </div>

  <form [formGroup]="dataUserForm" (ngSubmit)="onSubmit('submit')">
    <div class="form_content">
      <div class="form_content">
        <div class="form_content_input">
          <mat-form-field appearance="outline" [style.margin-right.px]="20">
            <mat-label>Du</mat-label>
            <input matInput [matDatepicker]="from" formControlName="from">
            <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
            <mat-datepicker #from></mat-datepicker>
          </mat-form-field>
          <span [style.margin-right.px]="20">-</span>
          <mat-form-field appearance="outline">
            <mat-label>Au</mat-label>
            <input matInput [matDatepicker]="to" formControlName="to" [min]="dataUserForm.get('from').value">
            <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
            <mat-datepicker #to></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <button type="submit" [style.width.px]="40">
        <fa-icon [icon]="faSearch"></fa-icon>
      </button>
    </div>
    <div class="btn_action">
      <fa-icon [icon]="faPrint" [style.margin-right.px]="10" (click)="printData()"></fa-icon>
      <fa-icon [icon]="faFileExcel"></fa-icon>
    </div>
  </form>

  <div class="content">
    <div class="ligne">
      <h3>Tri</h3>
      <p *ngIf="!arrayTri?.length" class="no_data"><strong>{{userName}}</strong> n'a pas paticipé au poste Tri du
        <strong>{{dataUserForm.get('from').value | date}}</strong>
        au
        <strong>{{dataUserForm.get('to').value | date}}</strong>
      </p>
      <ul class="ligne_content" *ngIf="arrayTri?.length">

        <!-- <li><strong>{{weightTri}}</strong> kg de linge trié</li> -->
        <li><strong>{{weightTriClicotte}}</strong> kg de linge à destination de Clicotte</li>
        <li><strong>{{weightTriDechet}}</strong> kg mis à la déchétterie</li>
        <li><strong>{{weightGoodCart}}</strong> kg trié</li>
      </ul>

      <div class="total" *ngIf="arrayTri?.length">
        Un total de <strong>{{weightTri}} kg</strong>
      </div>

    </div>

    <div class="ligne">
      <h3>Cintrage</h3>
      <p *ngIf="!arrayCintrage?.length" class="no_data"><strong>{{userName}}</strong> n'a pas paticipé au poste Cintrage
        du
        <strong>{{dataUserForm.get('from').value | date}}</strong>
        au
        <strong>{{dataUserForm.get('to').value | date}}</strong>
      </p>

      <!-- <p *ngIf="arrayTri.length"><strong>{{userName}}</strong> a cintré : </p> -->
      <ul class="ligne_content" *ngIf="arrayCintrage?.length">
        <li><strong>{{arrayCintrageMen}}</strong> article<span *ngIf="arrayCintrageMen > 1">s</span> homme</li>
        <li><strong>{{arrayCintrageWommen}}</strong> article<span *ngIf="arrayCintrageWommen > 1">s</span> femme</li>
        <li><strong>{{arrayCintrageKids}}</strong> article<span *ngIf="arrayCintrageKids > 1">s</span> enfant </li>
        <li><strong>{{arrayCintrageShoesAcc}}</strong> article<span *ngIf="arrayCintrageShoesAcc > 1">s</span>
          chaussures/accessoires</li>
      </ul>

      <div class="total" *ngIf="arrayCintrage?.length">
        Un total de <strong>{{cintrageTotalValue}} article<span *ngIf="cintrageTotalValue > 1">s</span></strong>
      </div>

    </div>

    <div class="ligne">
      <h3>Vente</h3>
      <p *ngIf="!arrayVente?.length" class="no_data"><strong>{{userName}}</strong> n'a pas paticipé au poste Vente du
        <strong>{{dataUserForm.get('from').value | date}}</strong>
        au
        <strong>{{dataUserForm.get('to').value | date}}</strong>
      </p>
      <p *ngIf="arrayVente?.length">{{user?.firstname}} a entré :</p>
      <ul class="ligne_content sales" *ngIf="arrayVente?.length">
        <li><strong>{{arrayVenteMen}}</strong> article<span *ngIf="arrayVenteMen > 1">s</span> homme</li>
        <li><strong>{{arrayVenteWommen}}</strong> article<span *ngIf="arrayVenteWommen > 1">s</span> femme</li>
        <li><strong>{{arrayVenteKids}}</strong> article<span *ngIf="arrayVenteKids > 1">s</span> enfant </li>
        <li><strong>{{arrayVenteShoesAcc}}</strong> article<span *ngIf="arrayVenteShoesAcc > 1">s</span>
          chaussures/accessoires</li>
        <li><strong>{{arrayVenteSelection}}</strong> article<span *ngIf="arrayVenteSelection > 1">s</span>
          sélection</li>
        <li><strong>{{arrayVenteCreation}}</strong> article<span *ngIf="arrayVenteCreation > 1">s</span>
          création</li>
      </ul>

      <div class="total" *ngIf="arrayVente?.length">
        Un total de <strong>{{venteTotalValue}} article<span *ngIf="venteTotalValue > 1">s</span></strong>
      </div>

    </div>

  </div>
</div>